import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { Car } from 'app/models/car.model';
import { Poligon } from 'app/models/poligon.model';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { PoligonService } from 'app/services/poligon.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
import { ZoneFormComponent } from '../zone-form/zone-form.component';
import { ZoneUpdateComponent } from '../zone-update/zone-update.component';

@Component({
    selector: 'zone-list',
    templateUrl: './zone-list.component.html',
    styleUrls: ['./zone-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ZoneListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    public companyId: number;
    private _zoneList: Array<Poligon> = [];

    public get userList(): Array<User> {
        return this._zoneList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<Poligon> = undefined;
    public get dataSource(): MatTableDataSource<Poligon> {
        return this._dataSource;
    }

    private _displayedColumns = ['id', 'name','treshold', 'points', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _dialog: MatDialog,
        private _spinner:NgxSpinnerService,
        private _toastService: ToasterService,
        private _poligonService: PoligonService,
        private _translateService:TranslateService,
        private _carService : CarService
    ) {
    }


    public async ngOnInit() {

        try {
            this.companyId = parseInt(localStorage.getItem("CompanyID"));
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
        await this.getZoneList();
    }
    private async getZoneList(): Promise<Array<Poligon>> {
        try {
            this._spinner.show('loading')
            this._zoneList = await this._poligonService.getPoligons(this.companyId);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    public async onZoneMap(element:Poligon){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.points=element.points;
        dialog.componentInstance.operation="multi-point";
    }
    
    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Poligon>(this._zoneList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public detailZone(polygon: Poligon) {
        this._dialog.open(ZoneFormComponent, {
            data: polygon,
            disableClose: false
        });
    }

    public UpdateZone(polygon:Poligon){
        const dialog = this._dialog.open(ZoneUpdateComponent, {
            data: cloneDeep(polygon),
            disableClose: false
        });
        dialog.componentInstance.model = cloneDeep(polygon);
        dialog.componentInstance.operation = "update"
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh()
            dialog.close();
        });
        
    }

    public async deleteZone(polygon: Poligon) {
        var cars:Array<Car>
        try {
            cars = await this._carService.getByPolygon(polygon.id);
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        if(cars.length != 0){
            this._toastService.toastWarning(this._translateService.instant("THERE_IS_A_CAR_ASSOCIATED_IS_A_CAR_ASSOCIATED_WITH_THE_REGION_FIRST_CHANGE_THE_POLYGON_OF_THE_CAR"))
            return;
        }
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen bölgeyi silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{ 
                await this._poligonService.delete(polygon);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })

        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
        this.refresh();
    }
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    refresh() {
        this.getZoneList();
    }
        
}
